module.exports = __webpack_public_path__ + "static/media/MonkLogo.4083fdf5.png";